export const OPTIMIZED_ROUTE_THRESHOLD = 7;
export const FLOOR_CHANGE_PENALTY = 30;
